import { useNavigate } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { ChevronDown, Check } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from '../ui/dropdown-menu';

const LUMINA_LOGO = "https://customer-assets.emergentagent.com/job_revenue-cycle-1/artifacts/wnwhtsce_lumina_logo_white.png";
const REVQ_LOGO = "https://customer-assets.emergentagent.com/job_medcycle-metrics/artifacts/700vz85m_revq_logo_white.png";
const ECHO_LOGO = "https://customer-assets.emergentagent.com/job_medcycle-metrics/artifacts/ddnrysy5_echo_logo_white.svg";

const APPS = [
  { key: 'echo', logo: ECHO_LOGO, href: '/echo', letter: 'E' },
  { key: 'lumina', logo: LUMINA_LOGO, href: '/lumina', letter: 'L' },
  { key: 'revq', logo: REVQ_LOGO, href: '/revq', letter: 'R' },
];

const AppSwitcher = ({ currentApp, collapsed, variant = 'sidebar' }) => {
  const navigate = useNavigate();
  const current = APPS.find(a => a.key === currentApp);

  if (variant === 'topbar') {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center gap-2 outline-none hover:opacity-80 transition-opacity" data-testid="app-switcher-trigger">
          <img src={current?.logo} alt={currentApp} className="h-6 w-auto" style={{ maxWidth: 100, objectFit: 'contain' }} />
          <ChevronDown className="h-3.5 w-3.5 text-white/50" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-56 ml-1" data-testid="app-switcher-menu">
          {APPS.map((app, i) => (
            <div key={app.key}>
              {i > 0 && app.key === 'revq' && <DropdownMenuSeparator />}
              <DropdownMenuItem
                className="gap-3 py-2.5 cursor-pointer"
                onClick={() => { if (app.key !== currentApp) navigate(app.href); }}
                data-testid={`app-switch-${app.key}`}
              >
                <img src={app.logo} alt={app.key} className="h-5 w-auto invert" />
                {app.key === currentApp && <Check className="h-4 w-4 ml-auto text-emerald-500" />}
              </DropdownMenuItem>
            </div>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <div className={cn("flex items-center h-16 px-4 border-b border-gray-800", collapsed ? "justify-center" : "justify-start")}>
      <DropdownMenu>
        <DropdownMenuTrigger className="flex items-center gap-2 outline-none hover:opacity-80 transition-opacity" data-testid="app-switcher-trigger">
          {!collapsed ? (
            <>
              <img src={current?.logo} alt={currentApp} className="h-7 w-auto" />
              <ChevronDown className="h-3.5 w-3.5 text-gray-500" />
            </>
          ) : (
            <div className="h-8 w-8 rounded-lg bg-gray-800 flex items-center justify-center hover:bg-gray-700 transition-colors">
              <span className="text-white font-bold text-sm">{current?.letter}</span>
            </div>
          )}
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" side={collapsed ? "right" : "bottom"} className="w-56 ml-1" data-testid="app-switcher-menu">
          {APPS.map((app, i) => (
            <div key={app.key}>
              {i > 0 && app.key === 'revq' && <DropdownMenuSeparator />}
              <DropdownMenuItem
                className="gap-3 py-2.5 cursor-pointer"
                onClick={() => { if (app.key !== currentApp) navigate(app.href); }}
                data-testid={`app-switch-${app.key}`}
              >
                <img src={app.logo} alt={app.key} className="h-5 w-auto invert" />
                {app.key === currentApp && <Check className="h-4 w-4 ml-auto text-emerald-500" />}
              </DropdownMenuItem>
            </div>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default AppSwitcher;
